import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  IntraDevDevelopment,
  IntraDevDevelopmentApi,
  IntraDevHistorique
} from '../../../../../shared/sdk';
import moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {etatDev, priorite, sectionDev, typeDev} from "../../../models/constDEV";
import {BugReportModaleDirective} from "../../modales/bugReport/bugReport.modale.directive";
import {PeopleWithrightsInterface} from '../../../../../core/interfaces/peopleWithrights.interface';
import {AppSessionService} from '../../../../../core/services/app.session.service';
import {ModalCompatibilityService} from '../../../../../core/services/modal-compatibility.service';
import {AppToasterService} from '../../../../../core/services/app.toaster.service';
import {AppGlobalEventManagerService} from '../../../../../core/services/app.globalEventManager.service';
import {FileFormDirective} from '../../../../../core/directives/form/typesFields/file/file.form.directive';
import {Tooltip} from 'primeng/tooltip';
import {Button} from 'primeng/button';
import { DestroyableComponent } from '../../../../../core/classes/destroyable.component';

@Component({
  selector: 'btnBugReport',
  standalone: true,
  templateUrl: './btnBugReport.partial.html',
  imports: [
    Tooltip,
    Button
  ]
})
export class BtnBugReportPartialDirective extends DestroyableComponent implements OnInit {
  @Output() clickevent: EventEmitter<any> = new EventEmitter();

  public sections = sectionDev;
  public types = typeDev;
  public etats = etatDev;
  public urgents = priorite;


  public user: PeopleWithrightsInterface;

  development: IntraDevDevelopment = new IntraDevDevelopment();
  histo: IntraDevHistorique = new IntraDevHistorique();

  protected moment = moment;

  addPJ = false;
  public formAddfile: FormGroup;
  @ViewChild('uploadFile', {static: false}) uploadFile: FileFormDirective;

  public folder: string = 'development';

  constructor(
    public _sessionService: AppSessionService,
    private _apiService: IntraDevDevelopmentApi,
    private modalService: ModalCompatibilityService,
    private toastr: AppToasterService,
    public formBuilder: FormBuilder,
    private appGlobalEventManagerService: AppGlobalEventManagerService
  ) {
    super();

    this.subscribe(this._sessionService.logguedAccountEmitter, (people) => {
      this.user = people;
    })
  }

  openBugReport(){
    const activeModal = this.modalService.open(BugReportModaleDirective, {
      size: 'lg',
      centered: true
    });
    activeModal.componentInstance.clickevent.subscribe((ret: IntraDevDevelopment) => {
      if (ret) {
        activeModal.close();
      }
    });
  }

  ngOnInit(): void {

  }


}
